<template>
  <!-- 底部 -->
  <footer class="footer">
       <div class="container">
         <!-- <p>京ICP备19010769号-2</p> -->
         <p class="copyright">Copyright © 版权所有 </p>
          <!-- <p>
            <span class="container-bar">关于我们</span>
            <span class="container-bar">用户帮助</span>
            <span class="container-bar">联系我们</span>
          </p>
          <p></p> -->
       </div>
  </footer>
</template>

<script type="text/javascript">
/**
 * 底部footer
 *
 * @requires App.vue
 * @author liguojie
 */
export default {
  name: 'coinDogFooter'
}
</script>

<style lang="scss" scoped>
 .footer{
   height:60px;
   background:rgba(33,33,42,1);
   display: flex;
   margin-top: 90px;
   .container{
    width:970px;
    height:60px;
    line-height: 60px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size:16px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(255,255,255,1);
    a{
      display: inline-block;
      margin-right: 30px;
      color: rgba(255,255,255,1);
    }
    .container-bar{
      cursor: pointer;
      margin-right: 60px;
    }
    .container-bar:last-child {
      margin-right:0;
    }
    .copyright{
      text-align: center;
      width: 100%;
    }
   }
 }
</style>
